
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta } from "/home/vsts/work/1/s/pages/index.vue?macro=true";
import { default as indexYrIjEjCjKZJ_45bSijDqxOpsUsaO_45R8_45yrHKLg_2x7o9QMeta } from "/home/vsts/work/1/s/pages/IC/index.vue?macro=true";
import { default as allzqPizV6qjtfWr2aoiFO4Z6auOS6bio_IjF6MeWcRrPsMeta } from "/home/vsts/work/1/s/pages/claims/all.vue?macro=true";
import { default as all77lPmL0knbh79Zoq5l5dFl3T__uIxPg3xhBYsNGhoRcMeta } from "/home/vsts/work/1/s/pages/postal/all.vue?macro=true";
import { default as indexKlYGgxN4rRx6LzCY2O3XJ_EA4_45ELGXMqUsxF04s0Xl0Meta } from "/home/vsts/work/1/s/pages/users/[id]/index.vue?macro=true";
import { default as carteiraeckuDO59BR1MgCzunPyEuh42B2UwQ793vcQv2Fl_45YhQMeta } from "/home/vsts/work/1/s/pages/users/[id]/carteira.vue?macro=true";
import { default as veiculosxeQ0s7XFi6B_45AYAgVpaLkaGc04qMKHjpKwXk9eribDQMeta } from "/home/vsts/work/1/s/pages/users/[id]/veiculos.vue?macro=true";
import { default as historicoH_45oZz0wjrUE_45WtMx5v_45_91nGKuQyClpKnYWhkZcTARYMeta } from "/home/vsts/work/1/s/pages/users/[id]/historico.vue?macro=true";
import { default as criar_45estacionamentoM_5snr2IabWSLlVQiEPzEUzgaolXCBvo1JIov_VcGHIMeta } from "/home/vsts/work/1/s/pages/users/[id]/criar-estacionamento.vue?macro=true";
import { default as _91id_93K74r2nadIz_45HcTf9xE9xAONXRTeqEkEICL6Tyn2jYjcMeta } from "/home/vsts/work/1/s/pages/users/[id].vue?macro=true";
import { default as agentLawvtTRiiFXjGDYMTVocwgKV3EnYEPhOfPo7i_sTePwMeta } from "/home/vsts/work/1/s/pages/agent/agent.vue?macro=true";
import { default as index9V4xhrAwkCxEbAexWP7yTFJ895ruDOPXZ1SFJTFTBsEMeta } from "/home/vsts/work/1/s/pages/agent/index.vue?macro=true";
import { default as indexlwVQcx0oYqb2LHGa_eC4OqKMfdDekYxmPY7wVkTSo_45gMeta } from "/home/vsts/work/1/s/pages/audit/index.vue?macro=true";
import { default as indexnthl2jHMts4b2tNuZZp_F1gsQ__45tzQXv3u5u71tmzy8Meta } from "/home/vsts/work/1/s/pages/legal/index.vue?macro=true";
import { default as _91id_932EY2g2DvtLkTXwn0jSshblZkPt2HXoPyfAuAdMAUsPwMeta } from "/home/vsts/work/1/s/pages/pedido/[id].vue?macro=true";
import { default as todoCCM7A3DGgu3EcrZMRVwPP3GBLCAx_45Oka9sAHK5WvP6IMeta } from "/home/vsts/work/1/s/pages/pedido/todo.vue?macro=true";
import { default as rotahvsls32jEXX9MBy6fGJ_OByNEoAV8cGzYekLfwpa0UcMeta } from "/home/vsts/work/1/s/pages/report/rota.vue?macro=true";
import { default as indexJiUrSG2rCbgm18ylPYy8s9ruqFCj2nZB83qP5YAu41wMeta } from "/home/vsts/work/1/s/pages/users/index.vue?macro=true";
import { default as indexsB6ZuXCzVosrMVG4KZOQwMNYN2N0WX04DjzW8YEQ5zsMeta } from "/home/vsts/work/1/s/pages/claims/index.vue?macro=true";
import { default as lawyerFh_tiGTm4G72_45Y2NnJnLujj5BJ6FWyeLIe0f7ONEfQ4Meta } from "/home/vsts/work/1/s/pages/legal/lawyer.vue?macro=true";
import { default as reviseANnNcDZXoFyl32qBBO4oJA5zufYAWi_45dMyRa_Tt9cBAMeta } from "/home/vsts/work/1/s/pages/legal/revise.vue?macro=true";
import { default as indexF3Dc1TJvjRmJYTzUsCaCbBWf0AtMx7nEymup0zW0jbQMeta } from "/home/vsts/work/1/s/pages/pedido/index.vue?macro=true";
import { default as emailCcrbKtjufpw_oayYdGvMqbgeYJTyaToOf6EbEIxKuLEMeta } from "/home/vsts/work/1/s/pages/postal/email.vue?macro=true";
import { default as indexiPoO7P7DlGYmrM34Eeqh_451HVThIssaSCMwTyfB7GgREMeta } from "/home/vsts/work/1/s/pages/postal/index.vue?macro=true";
import { default as indexxzKC6J8GPOVbi5gEYM4uEtE_455OuHNyE89KVG_7zvz2YMeta } from "/home/vsts/work/1/s/pages/report/index.vue?macro=true";
import { default as indexXo6V_452AXsbAmWYmPjcXkW4IPFskn4hhL_56avbWDrwkMeta } from "/home/vsts/work/1/s/pages/account/index.vue?macro=true";
import { default as decisorfcI2Wn_ZqvaNKzdCDvrYB9OYdoEo0BN7sxbMb7x1bFsMeta } from "/home/vsts/work/1/s/pages/agent/decisor.vue?macro=true";
import { default as indexvHYx1DN8G_45R1aZrd03usJV2bFEerS4nTkDa0f6c9dZQMeta } from "/home/vsts/work/1/s/pages/parking/index.vue?macro=true";
import { default as resentmLu0ORxYEKMPdKPWjzcTCXBOMCzDJY8uKdnmR_GL_g8Meta } from "/home/vsts/work/1/s/pages/postal/resent.vue?macro=true";
import { default as agendaMFmedjCH9zDfviLsys3JFV7DAL_CeYwZg5pej9hprrIMeta } from "/home/vsts/work/1/s/pages/report/agenda.vue?macro=true";
import { default as agenteYUoKcVroPdqWRaNgd4R0pjuZkoyvq3fyBbhYHYKvq6AMeta } from "/home/vsts/work/1/s/pages/report/agente.vue?macro=true";
import { default as resumolsf6wuzS9onmS772YM57KjWEB5SFAqGukmxeqb_YYeIMeta } from "/home/vsts/work/1/s/pages/report/resumo.vue?macro=true";
import { default as agentdsR0NczRgsDIJsbntUkpsuwucbuG4NsvtJ16RtTapSAMeta } from "/home/vsts/work/1/s/pages/signing/agent.vue?macro=true";
import { default as indexyP0PdIKNcC7JIVLEJoJ9bKIxT7Ob5YM4C6fPUuWH1FYMeta } from "/home/vsts/work/1/s/pages/signing/index.vue?macro=true";
import { default as alertsOx_tcc3mZ_45qCGPpgVsuGhuvDqJcrzE_4577c3VkG9BKSUMeta } from "/home/vsts/work/1/s/pages/account/alerts.vue?macro=true";
import { default as formbbAYT6k7KoGUzC6oCgunQJKfeuNWJ_45GwqKu_QuxM4OIMeta } from "/home/vsts/work/1/s/pages/campanhas/form.vue?macro=true";
import { default as historyocXuaKkSsiMVsj1f5ilg00gOd6i5dPk9araxt0vLKj0Meta } from "/home/vsts/work/1/s/pages/claims/history.vue?macro=true";
import { default as pendingX6rMyUGrHRcZ9HyvUfpfei9VMS39k36Y4Qtj2sZlaY0Meta } from "/home/vsts/work/1/s/pages/claims/pending.vue?macro=true";
import { default as transitMP7qgSqZOH4TE33cQsmxkTLPlN9gnFZhrpmrGZmrrugMeta } from "/home/vsts/work/1/s/pages/claims/transit.vue?macro=true";
import { default as indexFjmRVq2aOs1KRYqhq0FweFWOKY26zdbFMvtfQU25dhUMeta } from "/home/vsts/work/1/s/pages/executor/index.vue?macro=true";
import { default as addTv_45IRZT0ojHYyFjEL0CNpW15k6U9_VUmheonXMVWBRoMeta } from "/home/vsts/work/1/s/pages/infraction/add.vue?macro=true";
import { default as approvedZ_pIm_45CidGhJJM0VNutZ3qorYQKuAZI_45lHVsayk08G4Meta } from "/home/vsts/work/1/s/pages/legal/approved.vue?macro=true";
import { default as index_VVV76YO9S7NIkRImWpIP1N3YA_8TdjW4us8p_u39BkMeta } from "/home/vsts/work/1/s/pages/messages/index.vue?macro=true";
import { default as anomalytl2ZrVPNwhEUxjRQhbM_45SW0SJSYlut_iUfrkecbVe2YMeta } from "/home/vsts/work/1/s/pages/pedido/anomaly.vue?macro=true";
import { default as deliverBlVW9Jt8fSQEDl6fSNkKt0uJDxCVkzZqTl_45mUeqrAiUMeta } from "/home/vsts/work/1/s/pages/postal/deliver.vue?macro=true";
import { default as historyof6MUUbbQMVIOqrqSity4g49XeByqoADzWQru87HRuAMeta } from "/home/vsts/work/1/s/pages/postal/history.vue?macro=true";
import { default as pendingpCYK_BbHXjFdhgQbzqCHeGb6cd9OWtuIfCXlusMWqaQMeta } from "/home/vsts/work/1/s/pages/postal/pending.vue?macro=true";
import { default as transitldz67SACf9Gg_z_458m4JUlFnTYuviwGj_I28bbthgPHgMeta } from "/home/vsts/work/1/s/pages/postal/transit.vue?macro=true";
import { default as billingoM31_ubYAK3Hr0gmgZKOnjhC1Bcc6DKNJwUFhRE3sVMMeta } from "/home/vsts/work/1/s/pages/report/billing.vue?macro=true";
import { default as indexOps_in1agWod3a4yGI9L7rDF9e9xA75JatzjYLpLus4Meta } from "/home/vsts/work/1/s/pages/timeline/index.vue?macro=true";
import { default as profileneIBNpiAJXNgblBLsDeUxIJLCxlaM_VelPto94z3WoIMeta } from "/home/vsts/work/1/s/pages/account/profile.vue?macro=true";
import { default as indexA0JsB8NUTEju90c_zP50Nt4EOwW_45eWNEzFxnZ7nm4okMeta } from "/home/vsts/work/1/s/pages/campanhas/index.vue?macro=true";
import { default as indexEeg0u2OpL27c1hudcLwdkSytjvVYxByUqkT6wswZ99MMeta } from "/home/vsts/work/1/s/pages/dashboard/index.vue?macro=true";
import { default as lawyerhScetXM0EFz9JGdpuS13tWarKjrmqTv2_jWrOeYMhH8Meta } from "/home/vsts/work/1/s/pages/executor/lawyer.vue?macro=true";
import { default as _91id_93W7xsTIGOz4NnzpW1184Iw_455vsIcHYZ_45btrAhPtc5lE4Meta } from "/home/vsts/work/1/s/pages/infraction/[id].vue?macro=true";
import { default as decisor1fcMtm_kmzt_45XX0_45wrxrL9vi7geDdby07k_0QTrD_doMeta } from "/home/vsts/work/1/s/pages/signing/decisor.vue?macro=true";
import { default as settingsNisJubPDUq_JGzzikv5Gl0QGt6khsz4dg6QLwQ9KxCQMeta } from "/home/vsts/work/1/s/pages/account/settings.vue?macro=true";
import { default as subscritor85zpK6LPP6YU_450gxCTFhKSJp0yti7TsEjw_M9vd9ExgMeta } from "/home/vsts/work/1/s/pages/agent/subscritor.vue?macro=true";
import { default as acessoxXdBCE2K4Dzmnec0uvdgrLT2mEh9n_45MRk97eb6LQfbYMeta } from "/home/vsts/work/1/s/pages/dashboard/acesso.vue?macro=true";
import { default as indexFraM049IJIhJwTwRVNUzh_QJTBGK8fVGupVJR4LvzfwMeta } from "/home/vsts/work/1/s/pages/infraction/index.vue?macro=true";
import { default as ditigalSignA5OQEjJrwqcqoUwcJZaNGKL9E5CyUbvgIdEEgFpV8mkMeta } from "/home/vsts/work/1/s/pages/agent/ditigalSign.vue?macro=true";
import { default as afeReportsMUKjeaHtoO9uJy2fNtFfiN6gfAo9mCHIXhvQjqR9cagMeta } from "/home/vsts/work/1/s/pages/report/afeReports.vue?macro=true";
import { default as dataPostalLAsqrmuMcUIENyj46yYXBL1F5lj3FL_45wZLWM5ipB1HAMeta } from "/home/vsts/work/1/s/pages/report/dataPostal.vue?macro=true";
import { default as audit_45streetEh8ny7OvJtt2Zx773GzgyCdxn9zyjT0dYhVf9XoLCDcMeta } from "/home/vsts/work/1/s/pages/audit/audit-street.vue?macro=true";
import { default as indexR_2B5qXa1goGAmc47LTWl1fgjbi5VS39eu9VlQmrR3kMeta } from "/home/vsts/work/1/s/pages/criar-pedido/index.vue?macro=true";
import { default as mobilitym9d3h3xcmgZqdLZO0_HldVKSpdi0EH_45WiW_45NTmlTzYoMeta } from "/home/vsts/work/1/s/pages/dashboard/mobility.vue?macro=true";
import { default as subscritorCRH6NFjupVv2QPUfpsMbVRDKq8jLKnRWj0zothWjOpwMeta } from "/home/vsts/work/1/s/pages/signing/subscritor.vue?macro=true";
import { default as _91id_93qGPHI9sZgGMnnp_45DVrf0PUVq3JohCqxw6ruzrllSKgEMeta } from "/home/vsts/work/1/s/pages/users/parking/[id].vue?macro=true";
import { default as _case_id_oldphiqH2AHMH_XG0OZ5boqGehvUrm9pYFQ7p2EXlgnOZ0Meta } from "/home/vsts/work/1/s/pages/pedido/_case_id_old.vue?macro=true";
import { default as ditigalSigngzgTISQKbmyS8gjqHbXLQ6P5_45XZWRf7QRgh16XHW4PYMeta } from "/home/vsts/work/1/s/pages/signing/ditigalSign.vue?macro=true";
import { default as _91id_93OktINwXu_yC_456X_454gWYhWczZn8o9_j80ctl2W07kHLcMeta } from "/home/vsts/work/1/s/pages/legal/documents/[id].vue?macro=true";
import { default as paymentDetailsInZ1yZwaKpKESCj_451ebTzQ8bAUc7cnm1OVGcRbLNAOcMeta } from "/home/vsts/work/1/s/pages/report/paymentDetails.vue?macro=true";
import { default as monitoramentoqmE_YxmjUx6VT190S3ByApKse_454DvvWyAUrofiYqqgUMeta } from "/home/vsts/work/1/s/pages/campanhas/monitoramento.vue?macro=true";
import { default as statusRequestUJwF3sr6p7a4PN6ex9pSrC0DizO8xQp12B_45VUpCp0Q8Meta } from "/home/vsts/work/1/s/pages/infraction/statusRequest.js?macro=true";
import { default as indexbx3zjvc_Hay4fEFQBR4Qe_45sj0ejhNIeg5As0d1HD9FkMeta } from "/home/vsts/work/1/s/pages/executor/documents/index.vue?macro=true";
import { default as infractionAddmWFc7mGM_UGWFZ1XGRwd_KIgpXTo9111Ng9THR0VotMMeta } from "/home/vsts/work/1/s/pages/infraction/infractionAdd.vue?macro=true";
import { default as resumo6nAUzdMmtz0xqEhJxlgh2HZB5TApi1RZzgfgGahOZ6sMeta } from "/home/vsts/work/1/s/pages/pedido/previewCase/resumo.vue?macro=true";
import { default as history9_MWG2FvfeODs_K7KmuDmWU7YDL1jH4mzd79_RNURWcMeta } from "/home/vsts/work/1/s/pages/pedido/previewCase/history.vue?macro=true";
import { default as paymentC_aonBxXkRvshs8d4AMNwy_5YOw8Qy_45X1EL2O5xOuRMMeta } from "/home/vsts/work/1/s/pages/pedido/previewCase/payment.vue?macro=true";
import { default as vehicleYKPQIA5paaxBjKBczuxzEDOsBGlbZ3_xYrJUWgV6vowMeta } from "/home/vsts/work/1/s/pages/pedido/previewCase/vehicle.vue?macro=true";
import { default as lockJzANUB1Dq29iWjGmvV0AB0G4YZ7ZKk7dM2rOKFI1OFIMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/lock.vue?macro=true";
import { default as documentsRpPcPTA50KC_miqr_Jslbm7tuVDsbTYNfxo3TPEj07MMeta } from "/home/vsts/work/1/s/pages/pedido/previewCase/documents.vue?macro=true";
import { default as claimsVwFYxqwH4BE97GAhkydZVC0vgz5OyWIZaZ0wh0J3W1wMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/claims.vue?macro=true";
import { default as requerenteAR6T3z_1z5_k_K2MgET6bN0KFrCnpnPENSsBHCNpgxsMeta } from "/home/vsts/work/1/s/pages/pedido/previewCase/requerente.vue?macro=true";
import { default as payment8G_45AgS7gSTHluD_45YaoGO0KnYR0m6FkCDG9jTaLK0QJMMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/payment.vue?macro=true";
import { default as vehiclemodoKlrMEwigQ94FtcFiRiNVtMjkP9jB5j7GgJSk_QUMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/vehicle.vue?macro=true";
import { default as idenficacaoMhSLPj8BM70htqeKjMyxmmG8Qsyqv2Y0gOPMQysyjOwMeta } from "/home/vsts/work/1/s/pages/pedido/previewCase/idenficacao.vue?macro=true";
import { default as timelineAdxI4NWyACCXp1a9lz5QcIcqvtgXcfgAHnxsZQCEEHsMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/timeline.vue?macro=true";
import { default as apreensaoqwBYlVyP5reNbX3x7Zcp8lxUqYmDblh3L3vqgf7WmQkMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/apreensao.vue?macro=true";
import { default as documentsjoz5X29Q8Rnefw5AzlqYvv7KoWW8I9U31WgLQMoI2iMMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/documents.vue?macro=true";
import { default as infraction6giPO1ELPuFBD8cqjX7Xgo2sgnjpMCOc_45jFyB6Cd_wQMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/infraction.vue?macro=true";
import { default as relationTo9LHAsy0T0RMs6gx0x3p_45Abhbn_45oPgHK0O5s3Gd6os2wMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/relationTo.vue?macro=true";
import { default as participantMGaQE9w3N2oUlSrRUqvyYW9joGzGTGPYzFX_45WlFPqOgMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/participant.vue?macro=true";
import { default as vehicleEdit5E2O0SM1V8mi_CuPANas0wOqYAY7x9hr5J0pFD_45qv4gMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/vehicleEdit.vue?macro=true";
import { default as notificationFtWib_s9Y4sD4UZDCx68Rq4EzfaWfVLjsZeANzPV8XYMeta } from "/home/vsts/work/1/s/pages/infraction/previewCase/notification.vue?macro=true";
import { default as infractionEditONUfMe3hbAL23MHmGdFXcxDdT7xn5Bro_8jVgCdt0l8Meta } from "/home/vsts/work/1/s/pages/infraction/previewCase/infractionEdit.vue?macro=true";
import { default as infractionResumeFiqPyWJtpRc6zlMPt5NkmwB4Z5vxF7ZEbkFavzje3Z0Meta } from "/home/vsts/work/1/s/pages/infraction/previewCase/infractionResume.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"login"},
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: "IC",
    path: "/IC",
    meta: indexYrIjEjCjKZJ_45bSijDqxOpsUsaO_45R8_45yrHKLg_2x7o9QMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/IC/index.vue")
  },
  {
    name: "claims-all",
    path: "/claims/all",
    component: () => import("/home/vsts/work/1/s/pages/claims/all.vue")
  },
  {
    name: "postal-all",
    path: "/postal/all",
    component: () => import("/home/vsts/work/1/s/pages/postal/all.vue")
  },
  {
    name: _91id_93K74r2nadIz_45HcTf9xE9xAONXRTeqEkEICL6Tyn2jYjcMeta?.name,
    path: "/users/:id()",
    component: () => import("/home/vsts/work/1/s/pages/users/[id].vue"),
    children: [
  {
    name: "users-id",
    path: "",
    meta: indexKlYGgxN4rRx6LzCY2O3XJ_EA4_45ELGXMqUsxF04s0Xl0Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/users/[id]/index.vue")
  },
  {
    name: "users-id-carteira",
    path: "carteira",
    meta: carteiraeckuDO59BR1MgCzunPyEuh42B2UwQ793vcQv2Fl_45YhQMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/users/[id]/carteira.vue")
  },
  {
    name: "users-id-veiculos",
    path: "veiculos",
    meta: veiculosxeQ0s7XFi6B_45AYAgVpaLkaGc04qMKHjpKwXk9eribDQMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/users/[id]/veiculos.vue")
  },
  {
    name: "users-id-historico",
    path: "historico",
    meta: historicoH_45oZz0wjrUE_45WtMx5v_45_91nGKuQyClpKnYWhkZcTARYMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/users/[id]/historico.vue")
  },
  {
    name: "users-id-criar-estacionamento",
    path: "criar-estacionamento",
    meta: criar_45estacionamentoM_5snr2IabWSLlVQiEPzEUzgaolXCBvo1JIov_VcGHIMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/users/[id]/criar-estacionamento.vue")
  }
]
  },
  {
    name: "agent-agent",
    path: "/agent/agent",
    meta: agentLawvtTRiiFXjGDYMTVocwgKV3EnYEPhOfPo7i_sTePwMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/agent/agent.vue")
  },
  {
    name: "agent",
    path: "/agent",
    meta: index9V4xhrAwkCxEbAexWP7yTFJ895ruDOPXZ1SFJTFTBsEMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/agent/index.vue")
  },
  {
    name: "audit",
    path: "/audit",
    meta: indexlwVQcx0oYqb2LHGa_eC4OqKMfdDekYxmPY7wVkTSo_45gMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/audit/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    meta: { ...(indexnthl2jHMts4b2tNuZZp_F1gsQ__45tzQXv3u5u71tmzy8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/legal/index.vue")
  },
  {
    name: "pedido-id",
    path: "/pedido/:id()",
    meta: { ...(_91id_932EY2g2DvtLkTXwn0jSshblZkPt2HXoPyfAuAdMAUsPwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/vsts/work/1/s/pages/pedido/[id].vue")
  },
  {
    name: "pedido-todo",
    path: "/pedido/todo",
    component: () => import("/home/vsts/work/1/s/pages/pedido/todo.vue")
  },
  {
    name: "report-rota",
    path: "/report/rota",
    meta: { ...(rotahvsls32jEXX9MBy6fGJ_OByNEoAV8cGzYekLfwpa0UcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/report/rota.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexJiUrSG2rCbgm18ylPYy8s9ruqFCj2nZB83qP5YAu41wMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/users/index.vue")
  },
  {
    name: "claims",
    path: "/claims",
    meta: indexsB6ZuXCzVosrMVG4KZOQwMNYN2N0WX04DjzW8YEQ5zsMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/claims/index.vue")
  },
  {
    name: "legal-lawyer",
    path: "/legal/lawyer",
    meta: { ...(lawyerFh_tiGTm4G72_45Y2NnJnLujj5BJ6FWyeLIe0f7ONEfQ4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/legal/lawyer.vue")
  },
  {
    name: "legal-revise",
    path: "/legal/revise",
    meta: { ...(reviseANnNcDZXoFyl32qBBO4oJA5zufYAWi_45dMyRa_Tt9cBAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/legal/revise.vue")
  },
  {
    name: "pedido",
    path: "/pedido",
    meta: { ...(indexF3Dc1TJvjRmJYTzUsCaCbBWf0AtMx7nEymup0zW0jbQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/pedido/index.vue")
  },
  {
    name: "postal-email",
    path: "/postal/email",
    meta: { ...(emailCcrbKtjufpw_oayYdGvMqbgeYJTyaToOf6EbEIxKuLEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/postal/email.vue")
  },
  {
    name: "postal",
    path: "/postal",
    meta: { ...(indexiPoO7P7DlGYmrM34Eeqh_451HVThIssaSCMwTyfB7GgREMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/postal/index.vue")
  },
  {
    name: "report",
    path: "/report",
    meta: { ...(indexxzKC6J8GPOVbi5gEYM4uEtE_455OuHNyE89KVG_7zvz2YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/report/index.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexXo6V_452AXsbAmWYmPjcXkW4IPFskn4hhL_56avbWDrwkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/account/index.vue")
  },
  {
    name: "agent-decisor",
    path: "/agent/decisor",
    meta: decisorfcI2Wn_ZqvaNKzdCDvrYB9OYdoEo0BN7sxbMb7x1bFsMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/agent/decisor.vue")
  },
  {
    name: "parking",
    path: "/parking",
    meta: { ...(indexvHYx1DN8G_45R1aZrd03usJV2bFEerS4nTkDa0f6c9dZQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/parking/index.vue")
  },
  {
    name: "postal-resent",
    path: "/postal/resent",
    component: () => import("/home/vsts/work/1/s/pages/postal/resent.vue")
  },
  {
    name: "report-agenda",
    path: "/report/agenda",
    meta: { ...(agendaMFmedjCH9zDfviLsys3JFV7DAL_CeYwZg5pej9hprrIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/report/agenda.vue")
  },
  {
    name: "report-agente",
    path: "/report/agente",
    meta: { ...(agenteYUoKcVroPdqWRaNgd4R0pjuZkoyvq3fyBbhYHYKvq6AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/report/agente.vue")
  },
  {
    name: "report-resumo",
    path: "/report/resumo",
    meta: resumolsf6wuzS9onmS772YM57KjWEB5SFAqGukmxeqb_YYeIMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/report/resumo.vue")
  },
  {
    name: "signing-agent",
    path: "/signing/agent",
    meta: { ...(agentdsR0NczRgsDIJsbntUkpsuwucbuG4NsvtJ16RtTapSAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/signing/agent.vue")
  },
  {
    name: "signing",
    path: "/signing",
    meta: { ...(indexyP0PdIKNcC7JIVLEJoJ9bKIxT7Ob5YM4C6fPUuWH1FYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/signing/index.vue")
  },
  {
    name: "account-alerts",
    path: "/account/alerts",
    meta: alertsOx_tcc3mZ_45qCGPpgVsuGhuvDqJcrzE_4577c3VkG9BKSUMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/account/alerts.vue")
  },
  {
    name: "campanhas-form",
    path: "/campanhas/form",
    meta: formbbAYT6k7KoGUzC6oCgunQJKfeuNWJ_45GwqKu_QuxM4OIMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/campanhas/form.vue")
  },
  {
    name: "claims-history",
    path: "/claims/history",
    component: () => import("/home/vsts/work/1/s/pages/claims/history.vue")
  },
  {
    name: "claims-pending",
    path: "/claims/pending",
    component: () => import("/home/vsts/work/1/s/pages/claims/pending.vue")
  },
  {
    name: "claims-transit",
    path: "/claims/transit",
    component: () => import("/home/vsts/work/1/s/pages/claims/transit.vue")
  },
  {
    name: "executor",
    path: "/executor",
    meta: indexFjmRVq2aOs1KRYqhq0FweFWOKY26zdbFMvtfQU25dhUMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/executor/index.vue")
  },
  {
    name: "infraction-add",
    path: "/infraction/add",
    meta: { ...(addTv_45IRZT0ojHYyFjEL0CNpW15k6U9_VUmheonXMVWBRoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/infraction/add.vue")
  },
  {
    name: "legal-approved",
    path: "/legal/approved",
    meta: approvedZ_pIm_45CidGhJJM0VNutZ3qorYQKuAZI_45lHVsayk08G4Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/legal/approved.vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: { ...(index_VVV76YO9S7NIkRImWpIP1N3YA_8TdjW4us8p_u39BkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/vsts/work/1/s/pages/messages/index.vue")
  },
  {
    name: "pedido-anomaly",
    path: "/pedido/anomaly",
    meta: { ...(anomalytl2ZrVPNwhEUxjRQhbM_45SW0SJSYlut_iUfrkecbVe2YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/pedido/anomaly.vue")
  },
  {
    name: "postal-deliver",
    path: "/postal/deliver",
    component: () => import("/home/vsts/work/1/s/pages/postal/deliver.vue")
  },
  {
    name: "postal-history",
    path: "/postal/history",
    component: () => import("/home/vsts/work/1/s/pages/postal/history.vue")
  },
  {
    name: "postal-pending",
    path: "/postal/pending",
    component: () => import("/home/vsts/work/1/s/pages/postal/pending.vue")
  },
  {
    name: "postal-transit",
    path: "/postal/transit",
    component: () => import("/home/vsts/work/1/s/pages/postal/transit.vue")
  },
  {
    name: "report-billing",
    path: "/report/billing",
    meta: billingoM31_ubYAK3Hr0gmgZKOnjhC1Bcc6DKNJwUFhRE3sVMMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/report/billing.vue")
  },
  {
    name: "timeline",
    path: "/timeline",
    meta: { ...(indexOps_in1agWod3a4yGI9L7rDF9e9xA75JatzjYLpLus4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/timeline/index.vue")
  },
  {
    name: "account-profile",
    path: "/account/profile",
    meta: profileneIBNpiAJXNgblBLsDeUxIJLCxlaM_VelPto94z3WoIMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/account/profile.vue")
  },
  {
    name: "campanhas",
    path: "/campanhas",
    meta: indexA0JsB8NUTEju90c_zP50Nt4EOwW_45eWNEzFxnZ7nm4okMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/campanhas/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexEeg0u2OpL27c1hudcLwdkSytjvVYxByUqkT6wswZ99MMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/dashboard/index.vue")
  },
  {
    name: "executor-lawyer",
    path: "/executor/lawyer",
    meta: lawyerhScetXM0EFz9JGdpuS13tWarKjrmqTv2_jWrOeYMhH8Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/executor/lawyer.vue")
  },
  {
    name: "infraction-id",
    path: "/infraction/:id()",
    meta: _91id_93W7xsTIGOz4NnzpW1184Iw_455vsIcHYZ_45btrAhPtc5lE4Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/infraction/[id].vue")
  },
  {
    name: "signing-decisor",
    path: "/signing/decisor",
    meta: { ...(decisor1fcMtm_kmzt_45XX0_45wrxrL9vi7geDdby07k_0QTrD_doMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/signing/decisor.vue")
  },
  {
    name: "account-settings",
    path: "/account/settings",
    meta: settingsNisJubPDUq_JGzzikv5Gl0QGt6khsz4dg6QLwQ9KxCQMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/account/settings.vue")
  },
  {
    name: "agent-subscritor",
    path: "/agent/subscritor",
    meta: subscritor85zpK6LPP6YU_450gxCTFhKSJp0yti7TsEjw_M9vd9ExgMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/agent/subscritor.vue")
  },
  {
    name: "dashboard-acesso",
    path: "/dashboard/acesso",
    meta: acessoxXdBCE2K4Dzmnec0uvdgrLT2mEh9n_45MRk97eb6LQfbYMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/dashboard/acesso.vue")
  },
  {
    name: "infraction",
    path: "/infraction",
    meta: { ...(indexFraM049IJIhJwTwRVNUzh_QJTBGK8fVGupVJR4LvzfwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/infraction/index.vue")
  },
  {
    name: "agent-ditigalSign",
    path: "/agent/ditigalSign",
    meta: ditigalSignA5OQEjJrwqcqoUwcJZaNGKL9E5CyUbvgIdEEgFpV8mkMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/agent/ditigalSign.vue")
  },
  {
    name: "report-afeReports",
    path: "/report/afeReports",
    meta: { ...(afeReportsMUKjeaHtoO9uJy2fNtFfiN6gfAo9mCHIXhvQjqR9cagMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/report/afeReports.vue")
  },
  {
    name: "report-dataPostal",
    path: "/report/dataPostal",
    meta: { ...(dataPostalLAsqrmuMcUIENyj46yYXBL1F5lj3FL_45wZLWM5ipB1HAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/report/dataPostal.vue")
  },
  {
    name: "audit-audit-street",
    path: "/audit/audit-street",
    component: () => import("/home/vsts/work/1/s/pages/audit/audit-street.vue")
  },
  {
    name: "criar-pedido",
    path: "/criar-pedido",
    meta: indexR_2B5qXa1goGAmc47LTWl1fgjbi5VS39eu9VlQmrR3kMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/criar-pedido/index.vue")
  },
  {
    name: "dashboard-mobility",
    path: "/dashboard/mobility",
    component: () => import("/home/vsts/work/1/s/pages/dashboard/mobility.vue")
  },
  {
    name: "signing-subscritor",
    path: "/signing/subscritor",
    meta: { ...(subscritorCRH6NFjupVv2QPUfpsMbVRDKq8jLKnRWj0zothWjOpwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/signing/subscritor.vue")
  },
  {
    name: "users-parking-id",
    path: "/users/parking/:id()",
    meta: _91id_93qGPHI9sZgGMnnp_45DVrf0PUVq3JohCqxw6ruzrllSKgEMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/users/parking/[id].vue")
  },
  {
    name: "pedido-_case_id_old",
    path: "/pedido/_case_id_old",
    component: () => import("/home/vsts/work/1/s/pages/pedido/_case_id_old.vue")
  },
  {
    name: "signing-ditigalSign",
    path: "/signing/ditigalSign",
    meta: { ...(ditigalSigngzgTISQKbmyS8gjqHbXLQ6P5_45XZWRf7QRgh16XHW4PYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/signing/ditigalSign.vue")
  },
  {
    name: "legal-documents-id",
    path: "/legal/documents/:id()",
    meta: { ...(_91id_93OktINwXu_yC_456X_454gWYhWczZn8o9_j80ctl2W07kHLcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/vsts/work/1/s/pages/legal/documents/[id].vue")
  },
  {
    name: "report-paymentDetails",
    path: "/report/paymentDetails",
    component: () => import("/home/vsts/work/1/s/pages/report/paymentDetails.vue")
  },
  {
    name: "campanhas-monitoramento",
    path: "/campanhas/monitoramento",
    meta: monitoramentoqmE_YxmjUx6VT190S3ByApKse_454DvvWyAUrofiYqqgUMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/campanhas/monitoramento.vue")
  },
  {
    name: "infraction-statusRequest",
    path: "/infraction/statusRequest",
    component: () => import("/home/vsts/work/1/s/pages/infraction/statusRequest.js")
  },
  {
    name: "executor-documents",
    path: "/executor/documents",
    component: () => import("/home/vsts/work/1/s/pages/executor/documents/index.vue")
  },
  {
    name: "infraction-infractionAdd",
    path: "/infraction/infractionAdd",
    component: () => import("/home/vsts/work/1/s/pages/infraction/infractionAdd.vue")
  },
  {
    name: "pedido-previewCase-resumo",
    path: "/pedido/previewCase/resumo",
    component: () => import("/home/vsts/work/1/s/pages/pedido/previewCase/resumo.vue")
  },
  {
    name: "pedido-previewCase-history",
    path: "/pedido/previewCase/history",
    component: () => import("/home/vsts/work/1/s/pages/pedido/previewCase/history.vue")
  },
  {
    name: "pedido-previewCase-payment",
    path: "/pedido/previewCase/payment",
    component: () => import("/home/vsts/work/1/s/pages/pedido/previewCase/payment.vue")
  },
  {
    name: "pedido-previewCase-vehicle",
    path: "/pedido/previewCase/vehicle",
    component: () => import("/home/vsts/work/1/s/pages/pedido/previewCase/vehicle.vue")
  },
  {
    name: "infraction-previewCase-lock",
    path: "/infraction/previewCase/lock",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/lock.vue")
  },
  {
    name: "pedido-previewCase-documents",
    path: "/pedido/previewCase/documents",
    component: () => import("/home/vsts/work/1/s/pages/pedido/previewCase/documents.vue")
  },
  {
    name: "infraction-previewCase-claims",
    path: "/infraction/previewCase/claims",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/claims.vue")
  },
  {
    name: "pedido-previewCase-requerente",
    path: "/pedido/previewCase/requerente",
    component: () => import("/home/vsts/work/1/s/pages/pedido/previewCase/requerente.vue")
  },
  {
    name: "infraction-previewCase-payment",
    path: "/infraction/previewCase/payment",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/payment.vue")
  },
  {
    name: "infraction-previewCase-vehicle",
    path: "/infraction/previewCase/vehicle",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/vehicle.vue")
  },
  {
    name: "pedido-previewCase-idenficacao",
    path: "/pedido/previewCase/idenficacao",
    component: () => import("/home/vsts/work/1/s/pages/pedido/previewCase/idenficacao.vue")
  },
  {
    name: "infraction-previewCase-timeline",
    path: "/infraction/previewCase/timeline",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/timeline.vue")
  },
  {
    name: "infraction-previewCase-apreensao",
    path: "/infraction/previewCase/apreensao",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/apreensao.vue")
  },
  {
    name: "infraction-previewCase-documents",
    path: "/infraction/previewCase/documents",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/documents.vue")
  },
  {
    name: "infraction-previewCase-infraction",
    path: "/infraction/previewCase/infraction",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/infraction.vue")
  },
  {
    name: "infraction-previewCase-relationTo",
    path: "/infraction/previewCase/relationTo",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/relationTo.vue")
  },
  {
    name: "infraction-previewCase-participant",
    path: "/infraction/previewCase/participant",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/participant.vue")
  },
  {
    name: "infraction-previewCase-vehicleEdit",
    path: "/infraction/previewCase/vehicleEdit",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/vehicleEdit.vue")
  },
  {
    name: "infraction-previewCase-notification",
    path: "/infraction/previewCase/notification",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/notification.vue")
  },
  {
    name: "infraction-previewCase-infractionEdit",
    path: "/infraction/previewCase/infractionEdit",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/infractionEdit.vue")
  },
  {
    name: "infraction-previewCase-infractionResume",
    path: "/infraction/previewCase/infractionResume",
    component: () => import("/home/vsts/work/1/s/pages/infraction/previewCase/infractionResume.vue")
  }
]